import { RouteType } from 'types/RouteType';
import { ServiceStoreType } from 'types/ServiceStoreTypes';
// import HardwareOverviewIcon from '@mui/icons-material/RvHookupOutlined';

const trailerInventoryRoute: RouteType[] = [
  {
    name: 'Trailer Inventory',
    path: '/trailer-inventory',
    layout: '/app',
    viewportCard: {
      header: {
        title: 'Trailer Inventory',
        // icon: HardwareOverviewIcon, // Icon placement might vary depending on design
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: {
        // component: () => import('./TrailerInventory.Body'),
        gridContainer: {
          namespace: 'TrailerInventoryDataGrid',
          storeName: 'trailerStore',
          // customEntity: 'trailerRows',
          columnHeaders: [
            {
              width: 150,
              title: 'Trailer',
              key: 'trailerNumber',
              dataType: 'number',
            },
            {
              width: 200,
              title: 'Type',
              key: 'trailerType',
            },
            {
              width: 200,
              title: 'License',
              key: 'licenseNumber',
            },
            {
              width: 200,
              title: 'VIN',
              key: 'vinNumber',
            },
            {
              width: 200,
              title: 'Company Owned',
              key: 'companyOwned',
              dataType: 'boolean',
            },
            {
              width: 200,
              title: 'Width Limit',
              key: 'widthLimit',
              dataType: 'number',
            },
            {
              width: 200,
              title: 'Height Limit',
              key: 'heightLimit',
              dataType: 'number',
            },
            {
              width: 200,
              title: 'Weight Limit',
              key: 'weightLimit',
              dataType: 'number',
            },
          ],
          defaultSort: {
            sortBy: ['trailerType', 'trailerNumber'],
            sortDirection: { trailerType: 'ASC', trailerNumber: 'ASC' },
          },
          enableInlineEdit: true,
          enableHover: true,
          onSubmitEdits: (id, data, rootStore) => {
            console.log('onSubmitEdits', id, data, rootStore);
            const trailerStore = rootStore.trailerStore as ServiceStoreType;
            trailerStore.patch(Number(id), data as object);
          },
        },
      },
    },
    group: 'Dispatch',
  requiresAuth: true, // Implicitly requires auth if requiresPermission is true
    requiresPermission: false,

    hidden: true,

    channels: ['trailer'],
    enableAutoFind: false,
    onEnter: async ({ rootStore }) => {
      const trailerStore = rootStore.trailerStore as ServiceStoreType;

      trailerStore.find();
    },
  },
];

export default trailerInventoryRoute;
